import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { OutrightFill } from 'src/domains/sportsbook/webview/components/raceBoxSelection/RaceBoxSelection.style';
import {
    TrapWrapperNextRaces,
    WidgetTrapBox,
} from 'src/domains/sportsbook/webview/components/nextRaces/raceBoxSelection/WidgetTrap.style';
import emptyGhSilk from 'src/domains/layouts/shared/assets/silk/empty-gh-silk.webp';

interface WidgetTrapPropsType {
    selectionId: SelectionId;
}

export const WidgetTrap = observer('WidgetTrap', (props: WidgetTrapPropsType) => {
    const { selectionId } = props;
    const selection = selectionId.getModel();
    const market = selection?.marketId2.getModel() ?? null;

    if (selection === null || market === null) {
        return null;
    }

    if (market.isOutright === true) {
        return <OutrightFill />;
    }

    return (
        <WidgetTrapBox>
            <TrapWrapperNextRaces
                number={selection.metaDataNumber}
                placeholder={emptyGhSilk}
                selectionId={selection.id2}
            />
        </WidgetTrapBox>
    );
});
